import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import moment from "moment";
import { ToastMessages } from "../../../../../components/toasts/toastMessages";
import { handleNarIngestionApiCall } from "./handleNarIngestionApiCall";

interface HandleNarIngestionUploadParams {
  selectedInsurance: string;
  selectedPlan: string;
  selectedDate: string;
  uploadedFiles: string[];
  fileType: "pdf" | "csv";
  startPage?: string;
  endPage?: string;
  onSuccess: () => void;
  setIsSubmitting: (isSubmitting: boolean) => void;
  neverExpire?: boolean;
}

export const handleNarIngestionUpload = async ({
  selectedInsurance,
  selectedPlan,
  selectedDate,
  uploadedFiles,
  fileType,
  startPage,
  endPage,
  onSuccess,
  setIsSubmitting,
  neverExpire = false,
}: HandleNarIngestionUploadParams) => {
  // Validation
  if (!selectedInsurance) {
    toast.error(ToastMessages.NAR_INGESTION_INSURANCE_ERROR);
    return;
  }

  if (!selectedPlan) {
    toast.error(ToastMessages.NAR_INGESTION_PLAN_ERROR);
    return;
  }

  if (!selectedDate) {
    toast.error(ToastMessages.NAR_INGESTION_DATE_ERROR);
    return;
  }

  if (uploadedFiles.length === 0) {
    toast.error(ToastMessages.NAR_INGESTION_FILE_ERROR);
    return;
  }

  // PDF ingestion requires an explicit page range for the file.
  if (fileType === "pdf") {
    const startPageNum = Number(startPage);
    const endPageNum = Number(endPage);
    const startValid = startPage !== "" && Number.isInteger(startPageNum) && startPageNum >= 1;
    const endValid = endPage !== "" && Number.isInteger(endPageNum) && endPageNum >= 1;
    if (!startValid || !endValid || endPageNum < startPageNum) {
      toast.error(ToastMessages.NAR_INGESTION_PAGE_RANGE_ERROR);
      return;
    }
  }

  // Parse the date - it comes in YYYY-MM-DD format
  const date = moment(selectedDate);

  // Validate the date
  if (!date.isValid()) {
    toast.error(ToastMessages.NAR_INGESTION_DATE_ERROR);
    return;
  }

  const month = date.month() + 1;
  const year = date.year();
  const day = date.date();

  await handleNarIngestionApiCall({
    payerType: selectedInsurance,
    subType: selectedPlan,
    month: month,
    year: year,
    documentType: fileType,
    ingest: false,
    day: day,
    startPage: fileType === "pdf" ? Number(startPage) : undefined,
    endPage: fileType === "pdf" ? Number(endPage) : undefined,
    onSuccess: onSuccess,
    setIsSubmitting: setIsSubmitting,
    neverExpire,
  });
};
